export default "__VITE_ASSET__DC04ap8s__"